import gql from 'graphql-tag';

const resetApiTokenMutation = gql`
  mutation adminUserResetToken($input: AdminUserResetApiTokenInput!) {
    adminUserResetToken(input: $input) {
      success
      errors
    }
  }
`;

export default resetApiTokenMutation;
